var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPausedBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 5.83301C3.33334 4.6545 3.33334 4.06524 3.69946 3.69912C4.06558 3.33301 4.65484 3.33301 5.83334 3.33301C7.01185 3.33301 7.60111 3.33301 7.96723 3.69912C8.33334 4.06524 8.33334 4.6545 8.33334 5.83301V14.1663C8.33334 15.3448 8.33334 15.9341 7.96723 16.3003C7.60111 16.6663 7.01185 16.6663 5.83334 16.6663C4.65484 16.6663 4.06558 16.6663 3.69946 16.3003C3.33334 15.9341 3.33334 15.3448 3.33334 14.1663V5.83301Z",
    stroke: "#616874",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83301C11.6667 4.6545 11.6667 4.06524 12.0328 3.69912C12.3989 3.33301 12.9882 3.33301 14.1667 3.33301C15.3452 3.33301 15.9344 3.33301 16.3006 3.69912C16.6667 4.06524 16.6667 4.6545 16.6667 5.83301V14.1663C16.6667 15.3448 16.6667 15.9341 16.3006 16.3003C15.9344 16.6663 15.3452 16.6663 14.1667 16.6663C12.9882 16.6663 12.3989 16.6663 12.0328 16.3003C11.6667 15.9341 11.6667 15.3448 11.6667 14.1663V5.83301Z",
    stroke: "#616874",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedBlack);
export default __webpack_public_path__ + "static/media/pausedBlack.e49d8acef955f4e5de5d5545adf03484.svg";
export { ForwardRef as ReactComponent };